import { useEffect } from 'react';
import { usePathname, useSearchParams } from 'next/navigation';
import { useRouter } from 'next/router';

import { useQuery } from '@tanstack/react-query';

import { MyCasesDashboardScreen } from './MyCases';
import { EmptyCasesDashboardScreen } from './EmptyCases';
import { caseApplicationsService, GET_CASES_CLIENTS } from '@/api';
import { useUser } from '@/hooks';
import { VerificationReminderModal } from '@/components/modals/VerificationReminderModal';

export const DashboardCasesScreen: React.FC = () => {
	const searchParams = useSearchParams();
	const pathname = usePathname();
	const { replace } = useRouter();
	const { user } = useUser();

	const params = new URLSearchParams(searchParams);

	useEffect(() => {
		if (!params.get('page')) {
			params.set('page', '1');
			replace(`${pathname}?${params.toString()}`);
		}
	}, []);

	const { data: cases, isLoading } = useQuery({
		queryKey: [GET_CASES_CLIENTS],
		queryFn: () =>
			caseApplicationsService.getAll({
				page: 1,
				limit: 1,
			}),
	});

	const listCases = cases?.data.items || [];

	return (
		<div className="flex flex-col justify-between h-auto lg:h-[80vh]">
			{!isLoading && listCases.length === 0 && <EmptyCasesDashboardScreen />}

			{!isLoading && listCases.length > 0 && <MyCasesDashboardScreen />}

			<VerificationReminderModal user={user} />
		</div>
	);
};
